import React, { useState } from 'react';

import { addToAgendaQueueAction } from 'actions/addConsumeAgendaActions';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { selectAddToAgendaState } from 'selectors/addToAgendaStateSelector';
import styled, { css } from 'styled-components';
import { StyledGrid, StyledTooltip } from 'styles/common';

import { CheckIcon2 } from 'constants/icons';
import { sendAddedOnboardingToOneOnOneEvent } from 'constants/mixpanelHelper';
import theme from 'constants/theme';

import { ButtonOutlined } from 'uiToolkit/Button';
import { Typography13 } from 'uiToolkit/Typography';

const ButtonWrapper = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;

const StyledButtonOutlined = styled(ButtonOutlined)`
  ${(props) =>
    props.disabled &&
    css`
      p {
        color: ${(props) => `${props.theme.palette.primary.main}40`};
      }

      background-color: white !important;
      border-color: ${(props) => `${props.theme.palette.primary.main}40`} !important;
    `};
`;

export const AgendaAdded = () => (
  <StyledGrid container alignItems="center" justify="center" topGutter={3} bottomGutter={3}>
    <CheckIcon2
      size="fixed10px"
      containerSize="fixed24px"
      circularOutline
      color={theme.palette.icons.green}
      rightGutter={2}
    />
    <Typography13 color={theme.palette.text.green}>Agenda Successfully added</Typography13>
  </StyledGrid>
);

export const LEVELUP_DISCUSSION_TEXT = `Have a Develop discussion to discuss career goals, competencies and next steps`;

export const Step1 = ({ employee, source }) => {
  const dispatch = useDispatch();

  const { showAddToAgenda } = useSelector(selectAddToAgendaState, shallowEqual);

  const [addToAgendaClicked, setAddToAgendaClicked] = useState(false);

  const handleAddToAgenda = () => {
    if (!showAddToAgenda) return;

    setAddToAgendaClicked(true);
    sendAddedOnboardingToOneOnOneEvent({
      eventProperties: {
        source,
      },
    });
    dispatch(
      addToAgendaQueueAction({
        isTagged: false,
        text: LEVELUP_DISCUSSION_TEXT,
      })
    );
  };

  return (
    <>
      <Typography13 topGutter={3} bottomGutter={2} color={theme.palette.text.label}>
        Step 1
      </Typography13>
      <Typography13 color={theme.palette.text.blackv1}>
        {LEVELUP_DISCUSSION_TEXT}
        {/* Have a Level Up discussion with
            <StyledLink to={getProfileRoute(employee?.id)}> {employee?.displayName} </StyledLink>
            to discuss career goals, competencies and next steps */}
      </Typography13>
      {addToAgendaClicked ? (
        <AgendaAdded />
      ) : (
        <StyledTooltip title={showAddToAgenda ? '' : "Please select a particular 1:1 to add to it's agenda"}>
          <ButtonWrapper>
            <StyledButtonOutlined
              disabled={!showAddToAgenda}
              borderColor="primary"
              style={{
                width: '100%',
                height: '40px',
              }}
              onClick={handleAddToAgenda}
            >
              <Typography13 color="primary" weight="600">
                Add Develop Discussion to Agenda
              </Typography13>
            </StyledButtonOutlined>
          </ButtonWrapper>
        </StyledTooltip>
      )}
    </>
  );
};
